import { render, staticRenderFns } from "./Dns.vue?vue&type=template&id=2d0713aa&scoped=true"
import script from "./Dns.vue?vue&type=script&lang=js"
export * from "./Dns.vue?vue&type=script&lang=js"
import style0 from "./Dns.vue?vue&type=style&index=0&id=2d0713aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0713aa",
  null
  
)

export default component.exports